// extracted by mini-css-extract-plugin
export default {"author-timestamp__author-name":"styles_author-timestamp__author-name__VuaZN","author-timestamp__timestamp":"styles_author-timestamp__timestamp__j9tze"};